// The scrollY at which .tournament-header-wrap (position: sticky, top: -1px -
// see Tournament.js/TournamentHeader.js) actually pins itself to the top.
//
// Tried computing this from the element's own `offsetTop` (relative to its
// nearest positioned ancestor, .page_container) plus that ancestor's own
// document position - looked right on several tabs, then came up short by
// the hero's own vertical margin on others (margin collapsing between
// .page_container's children and .page_container itself makes the exact
// shortfall vary by tab/content, not a single fixed constant), so scrollTo
// using that number sometimes left the header still ~20px short of actually
// being stuck.
//
// This instead reads the element's TRUE natural-flow position directly:
// temporarily drop it out of `position: sticky` (so its rect reflects where
// it would sit in plain document flow, immune to whatever its current stuck/
// unstuck state already is) via a synchronous style read-and-restore - no
// visible flash, since nothing paints between the two writes, only a forced
// layout. transition is also neutralized for the same reason a bare
// position flip would otherwise animate.
export default function getTournamentHeaderStickyScrollY() {
    const wrap = document.querySelector(".tournament-header-wrap");
    if (!wrap) return 0;
    const prevPosition = wrap.style.position;
    const prevTransition = wrap.style.transition;
    wrap.style.transition = "none";
    wrap.style.position = "static";
    const rect = wrap.getBoundingClientRect();
    const naturalDocY = rect.top + window.scrollY;
    wrap.style.position = prevPosition;
    wrap.style.transition = prevTransition;
    return naturalDocY + 1;
}
